/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Manage_Aria_LabelInputs */

const en_speakers_manage_aria_label = /** @type {(inputs: Speakers_Manage_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage speakers`)
};

const fr_speakers_manage_aria_label = /** @type {(inputs: Speakers_Manage_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerer les intervenants`)
};

const de_speakers_manage_aria_label = /** @type {(inputs: Speakers_Manage_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprecher verwalten`)
};

const it_speakers_manage_aria_label = /** @type {(inputs: Speakers_Manage_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisci gli altoparlanti`)
};

const ru_speakers_manage_aria_label = /** @type {(inputs: Speakers_Manage_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управление динамиками`)
};

const es_speakers_manage_aria_label = /** @type {(inputs: Speakers_Manage_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrar altavoces`)
};

const zh_cn2_speakers_manage_aria_label = /** @type {(inputs: Speakers_Manage_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理演讲者`)
};

const ja_speakers_manage_aria_label = /** @type {(inputs: Speakers_Manage_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スピーカーを管理する`)
};

const hi_speakers_manage_aria_label = /** @type {(inputs: Speakers_Manage_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वक्ताओं का प्रबंधन करें`)
};

const pt_pt2_speakers_manage_aria_label = /** @type {(inputs: Speakers_Manage_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerenciar alto-falantes`)
};

/**
* | output |
* | --- |
* | "Manage speakers" |
*
* @param {Speakers_Manage_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_manage_aria_label = /** @type {((inputs?: Speakers_Manage_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Manage_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speakers_manage_aria_label(inputs)
	if (locale === "de") return de_speakers_manage_aria_label(inputs)
	if (locale === "it") return it_speakers_manage_aria_label(inputs)
	if (locale === "ru") return ru_speakers_manage_aria_label(inputs)
	if (locale === "es") return es_speakers_manage_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_speakers_manage_aria_label(inputs)
	if (locale === "ja") return ja_speakers_manage_aria_label(inputs)
	if (locale === "hi") return hi_speakers_manage_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_speakers_manage_aria_label(inputs)
	return en_speakers_manage_aria_label(inputs)
});